<script>
import { required, numeric, alphaNum } from 'vuelidate/lib/validators';
import UiTextField from './UiTextField.vue';

export default {
  props: {
    isOneLine: {
      type: Boolean,
      default: false,
    },
    customFields: {
    },
  },
  components: {
    UiTextField,
  },
  data() {
    return {
      clientId: '',
      innerCustomFields: this.customFields || [],
    };
  },
  validations() {
    return {
      innerCustomFields: {
        $each: {
          value: {
            required(value, field) {
              // only validate if the field itself is required
              return field.required ? required(value) : true;
            },
            numeric(value, field) {
              // only validate if the field expects numeric
              return field.data_type_accepted === 'numeric' && value
                ? numeric(value)
                : true;
            },
            alphaNum(value, field) {
              // only validate if the field expects alphanumeric
              return field.data_type_accepted === 'alphanumeric' && value
                ? alphaNum(value)
                : true;
            },
          },
        },
      },
    };
  },


  mounted() {
    console.log('custom fields', this.customFields);
    this.innerCustomFields = this.customFields.map(field => ({
      ...field,
      value: '',
    }));
  },
  methods: {
    getErrorText(field, vField) {
      if (!vField || !vField.$error) return '';

      if (vField.required === false) {
        return this.$t('This field is required');
      }
      if (vField.numeric === false) {
        return this.$t('This field must be numeric');
      }
      if (vField.alphaNum === false) {
        return this.$t('This field must be alphanumeric');
      }
      return '';
    },
    emitCustomFields() {
      // Emit a deep copy to avoid mutating parent state directly
      this.$emit('update:innerCustomFields', JSON.parse(JSON.stringify(this.innerCustomFields)));
    },
    validate() {
      this.$v.$touch();
      return {
        isValid: !this.$v.$invalid,
      };
    },
  },
  name: 'InvoiceCustomFields',
};
</script>

<template>
  <div :class="[$style.formSectionCustomField]">
    <div :class="[$style.formItem, { [$style._oneLine]: isOneLine }]">
      <h4 class="textColor"> Custom Fields</h4>
    </div>
    <div class="billingfields">
      <UiTextField
        v-for="(field, index) in innerCustomFields"
        :key="index"
        autocomplete="off"
        :type="field.data_type_accepted === 'numeric' ? 'number' : 'text'"
        v-model="field.value"
        :hasError="$v.innerCustomFields.$each[index].value.$error"
        :errorText="getErrorText(field, $v.innerCustomFields.$each[index].value)"
        :label="$t(field.field_name)"
        @input="emitCustomFields"
      />
  </div>
  </div>
</template>
<style>
.billingfields {
  width:100%;
}
</style>
<style module lang="scss">
.formSectionCustomField {
  display: flex;
  flex-wrap: wrap;
  position: relative;
  align-content: flex-start;
  justify-content: space-between;
}
.formItem {
  display: flex;
  justify-content: space-between;
  width: 100%;
  position: relative;

  &._oneLine {
    width: calc(50% - 10px);
  }
}
</style>
